import type { AspectRatioOption, ResolutionOption } from "./types";

export const RESOLUTIONS: ResolutionOption[] = [
  { id: "1k", label: "1K" },
  { id: "2k", label: "2K" },
  { id: "4k", label: "4K" },
];

export const ASPECT_RATIOS: AspectRatioOption[] = [
  { id: "21:9", label: "21:9", icon: "ultra-wide" },
  { id: "16:9", label: "16:9", icon: "wide" },
  { id: "4:3", label: "4:3", icon: "standard" },
  { id: "3:2", label: "3:2", icon: "photo" },
  { id: "1:1", label: "1:1", icon: "square" },
  { id: "9:16", label: "9:16", icon: "portrait" },
  { id: "3:4", label: "3:4", icon: "portrait-standard" },
  { id: "2:3", label: "2:3", icon: "portrait-photo" },
  { id: "5:4", label: "5:4", icon: "landscape-compact" },
  { id: "4:5", label: "4:5", icon: "portrait-compact" },
];
